import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Sidebar from '../../components/feature/Sidebar';
import HeroSection from './components/HeroSection';
import GameCategories from './components/GameCategories';
import ArticleGrid from './components/ArticleGrid';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      
      <main className="pt-16 sm:pt-20">
        <HeroSection />
        
        <GameCategories />
        
        <section className="py-12 sm:py-16 lg:py-20 bg-dark-bg">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex flex-col lg:flex-row gap-6 sm:gap-8 lg:gap-12">
              <div className="flex-1 min-w-0">
                <ArticleGrid />
              </div>
              <div className="w-full lg:w-auto">
                <Sidebar />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
